export const messages = {
  en: {
    mappingManage: {
      allConfig: 'All Configurations',
      enterName: 'Please enter name',
      enterKey: 'Please enter key',
      search: 'Search',
      add: 'Add',
      codeId: 'Code ID',
      domain: 'Domain',
      name: 'Name',
      key: 'Key',
      value: 'Value',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      tip: 'Note: After modification, you need to refresh all caches (ALL) in Cache -> Refresh Cache'
    },
    addMapping: {
      title: 'Add Mapping',
      configItem: 'Configuration Item',
      selectConfigItem: 'Required, please select configuration item',
      name: 'Name',
      enterName: 'Required, please enter name',
      key: 'Key',
      enterKey: 'Required, please enter key',
      value: 'Value',
      enterValue: 'Required, please enter value',
      remark: 'Remark',
      enterRemark: 'Optional, please enter remark',
      cancel: 'Cancel',
      save: 'Save',
      domainRequired: 'Domain cannot be empty',
      domainMaxLength: 'Domain length cannot exceed 50',
      nameRequired: 'Name cannot be empty',
      nameLength: 'Name must be between 2-50 characters',
      keyRequired: 'Key cannot be empty',
      keyLength: 'Key must be between 1-100 characters',
      valueRequired: 'Value cannot be empty',
      valueLength: 'Value must be between 1-100 characters',
      saveSuccess: 'Added successfully'
    },
    editMapping: {
      title: 'Edit Mapping',
      domain: 'Domain',
      selectConfigItem: 'Required, please select configuration item',
      name: 'Name',
      enterName: 'Required, please enter name',
      key: 'Key',
      enterKey: 'Required, please enter key',
      value: 'Value',
      enterValue: 'Required, please enter value',
      remark: 'Remark',
      enterRemark: 'Optional, please enter remark',
      cancel: 'Cancel',
      save: 'Save',
      domainRequired: 'Domain cannot be empty',
      domainMaxLength: 'Domain length cannot exceed 50',
      nameRequired: 'Name cannot be empty',
      nameLength: 'Name must be between 2-50 characters',
      keyRequired: 'Key cannot be empty',
      keyLength: 'Key must be between 1-100 characters',
      valueRequired: 'Value cannot be empty',
      valueLength: 'Value must be between 1-100 characters',
      idRequired: 'Code ID cannot be empty',
      saveSuccess: 'Modified successfully'
    },
    deleteMapping: {
      title: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this mapping?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    mappingManage: {
      allConfig: '全部配置',
      enterName: '请输入名称',
      enterKey: '请输入键',
      search: '查询',
      add: '添加',
      codeId: '编码ID',
      domain: '域',
      name: '名称',
      key: '键',
      value: '值',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      tip: '温馨提示：改动后，需要到 缓存-> 刷新缓存 下缓存 刷新所有缓存（ALL）'
    },
    addMapping: {
      title: '添加映射',
      configItem: '配置项',
      selectConfigItem: '必填，请选择配置项',
      name: '名称',
      enterName: '必填，请填写名称',
      key: '键',
      enterKey: '必填，请填写键',
      value: '值',
      enterValue: '必填，请填写值',
      remark: '备注',
      enterRemark: '选填，请填写备注',
      cancel: '取消',
      save: '保存',
      domainRequired: '域不能为空',
      domainMaxLength: '域长度不能超过50',
      nameRequired: '名称不能为空',
      nameLength: '名称必须在2至50字符之间',
      keyRequired: '键不能为空',
      keyLength: '键必须在1至100之间',
      valueRequired: '值不能为空',
      valueLength: '值必须在1至100之间',
      saveSuccess: '添加成功'
    },
    editMapping: {
      title: '修改编码映射',
      domain: '域',
      selectConfigItem: '必填，请选择配置项',
      name: '名称',
      enterName: '必填，请填写名称',
      key: '键',
      enterKey: '必填，请填写键',
      value: '值',
      enterValue: '必填，请填写值',
      remark: '备注',
      enterRemark: '选填，请填写备注',
      cancel: '取消',
      save: '保存',
      domainRequired: '域不能为空',
      domainMaxLength: '域长度不能超过50',
      nameRequired: '名称不能为空',
      nameLength: '名称必须在2至50字符之间',
      keyRequired: '键不能为空',
      keyLength: '键必须在1至100之间',
      valueRequired: '值不能为空',
      valueLength: '值必须在1至100之间',
      idRequired: '编码ID不能为空',
      saveSuccess: '修改成功'
    },
    deleteMapping: {
      title: '请确认您的操作',
      confirmDelete: '确定删除编码映射',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}